import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useSubscriptionApi() {

  const { config, apiFetch } = useContext(GlobalContext);
  const BASE_URL =
    config?.REACT_APP_BASE_URL || "http://localhost:3000";

  // ---------------- AUTH HEADERS ----------------
  function getAuthHeaders() {
    const token = localStorage.getItem("token");

    return {
      "Content-Type": "application/json",
      "X-token": token || "",
    };
  }

  // =====================================================
  // 📜 LIST DELIVERED DEVICES + SUBSCRIPTIONS
  // =====================================================
  async function getAllSubscriptions({
    limit = 10,
    offset = 0,
    ...filters
  }) {
    const response = await apiFetch(
      `${BASE_URL}/get_all_device_subscriptions`,
      {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          limit,
          offset,
          ...filters,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success)
      throw new Error(data.message || "Failed to fetch subscriptions");

    return data;
  }

  // =====================================================
  // ✅ ENABLE SUBSCRIPTION
  // =====================================================
  async function enableSubscription({
    deviceId,
    validFrom,
    validThrough,
    gracePeriodDays = 30,
  }) {
    const response = await apiFetch(
      `${BASE_URL}/enable_device_subscription`,
      {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          deviceId,
          validFrom,
          validThrough,
          gracePeriodDays,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success)
      throw new Error(data.message || "Failed to enable subscription");

    return data;
  }

  // =====================================================
  // 🔁 EXTEND SUBSCRIPTION
  // =====================================================
async function extendSubscription({
  deviceId,
  validFrom,
  validThrough,
  gracePeriodDays = 30,
}) {
  const response = await apiFetch(
    `${BASE_URL}/extend_device_subscription`,
    {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        deviceId,
        validFrom,
        validThrough,
        gracePeriodDays,
      }),
    }
  );

  const data = await response.json();

  if (!response.ok || !data.success)
    throw new Error(data.message || "Failed to extend subscription");

  return data;
}

  // =====================================================
  // ⛔ DISABLE SUBSCRIPTION
  // =====================================================
  async function disableSubscription({ deviceId }) {
    const response = await apiFetch(
      `${BASE_URL}/disable_device_subscription`,
      {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          deviceId,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success)
      throw new Error(data.message || "Failed to disable subscription");

    return data;
  }

  // =====================================================
  // 🔍 GET SINGLE DEVICE SUBSCRIPTION
  // =====================================================
  async function getDeviceSubscription(deviceId) {
    const response = await apiFetch(
      `${BASE_URL}/get_device_subscription/${deviceId}`,
      {
        method: "GET",
        headers: getAuthHeaders(),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success)
      throw new Error(data.message || "Failed to fetch subscription");

    return data;
  }

  // ---------------- EXPORT ----------------
  return {
    getAllSubscriptions,
    enableSubscription,
    extendSubscription,
    disableSubscription,
    getDeviceSubscription,
  };
}
